import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import * as actions from "actions/client_settings"
import Layout from "layout"
//import { useScript } from "./userScript/userScript"


function App({
  auth,
  history,
  messages,
  locale,
  fetchClientSettings,
  location,
  appData,
  actionCalls,
}) {
  // 🔽 Lataa ulkoiset skriptit kerran
  //useScript("https://js.stripe.com/v3/", "stripe-js")
  //useScript("https://widget.cloudinary.com/v2.0/global/all.js", "cloudinary-widget")

  // 🔽 Fethc client settings once
  useEffect(() => {
    fetchClientSettings()
  }, [fetchClientSettings])

  if (!appData.clientSettingsFetched) return null

  return (
    <Layout
      auth={auth}
      history={history}
      messages={messages}
      locale={locale}
      location={location}
      actionCalls={actionCalls}
    />
  )
}

const mapStateToProps = (state) => ({
  auth: state.reducers.auth,
  locale: state.intl.locale,
  messages: state.intl.messages,
  appData: state.reducers.appData,
  actionCalls: state.reducers.actionCalls,
})

export default connect(mapStateToProps, actions)(withRouter(App))
